<div class="settings-page units-page">
  <div class="settings-topbar">
    <div class="topbar-left">
      <h1>
        Units of Measure
        <small>Standard measurement units</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        Settings / <span class="current">Units of Measure</span>
      </div>
    </div>
    <div class="topbar-right">
      <button type="button" class="btn btn-primary" (click)="openModal()">
        <i class="bi bi-plus-circle"></i> Add Unit
      </button>
    </div>
  </div>

  <div class="settings-table-wrap">
    <div class="table-scroll">
      <table class="report-data-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Abbreviation</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of units(); track row.id) {
            <tr>
              <td><span class="fw-semibold">{{ row.code }}</span></td>
              <td>{{ row.name }}</td>
              <td>
                <span class="meta-badge primary unit-abbreviation">
                  {{ row.abbreviation }}
                </span>
              </td>
              <td>
                <span class="status-pill" [class.active]="row.status === 'active'">
                  {{ row.status }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action edit" title="Edit unit" (click)="openEdit(row)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  @if (auth.hasPermission('edit_settings')) {
                  <button type="button" class="btn-action delete" title="Delete unit" (click)="deleteRow(row)">
                    <i class="bi bi-trash"></i>
                  </button>
                  }
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5" class="text-center py-4 text-muted">
                <i class="bi bi-inbox empty-state-icon"></i>
                No units found. Click "Add Unit" to create one.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showModal()) {
  <div class="modal-overlay open" (click)="closeModal()">
    <div class="settings-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">
          <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
          {{ isEditing() ? 'Edit Unit' : 'Add Unit' }}
        </h2>
        <button type="button" class="close-btn" (click)="closeModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Code</label>
          @if (isEditing() && unitForm.code) {
            <input type="text" class="form-control" [value]="unitForm.code" disabled />
            <small class="text-muted">Generated automatically and cannot be changed.</small>
          } @else {
            <input type="text" class="form-control" value="Auto-generated on save" disabled />
            <small class="text-muted">A unique code is created when you save.</small>
          }
        </div>
        <div class="form-group">
          <label class="form-label">Name <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="unitForm.name"
            placeholder="Enter unit name (e.g., Kilogram, Meter)"
            [class.is-invalid]="!unitForm.name && unitForm.name !== undefined"
          />
          @if (!unitForm.name && unitForm.name !== undefined) {
            <div class="invalid-feedback">Name is required</div>
          }
        </div>
        <div class="form-group">
          <label class="form-label">Abbreviation <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="unitForm.abbreviation"
            placeholder="Enter abbreviation (e.g., kg, m, l)"
            [class.is-invalid]="!unitForm.abbreviation && unitForm.abbreviation !== undefined"
          />
          @if (!unitForm.abbreviation && unitForm.abbreviation !== undefined) {
            <div class="invalid-feedback">Abbreviation is required</div>
          }
          <small class="form-hint text-muted">Short form used in labels and reports</small>
        </div>
        <div class="form-group">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="unitForm.status">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="bi bi-x-lg"></i> Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
}

@if (showToast()) {
  <div class="toast-container show">
    <div class="toast success">
      <div class="toast-icon"><i class="bi bi-check-circle-fill"></i></div>
      <div class="toast-content">
        <div class="toast-title">Success!</div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
